module.exports = __webpack_public_path__ + "img/doctors.1d0a710b.svg";